import { render, staticRenderFns } from "./historyModal.vue?vue&type=template&id=50396306&scoped=true&"
import script from "./historyModal.vue?vue&type=script&lang=js&"
export * from "./historyModal.vue?vue&type=script&lang=js&"
import style0 from "./historyModal.vue?vue&type=style&index=0&id=50396306&prod&lang=scss&style=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50396306",
  null
  
)

export default component.exports